
const $ = jQuery;

$(document).ready(() => {
    const body = $('body');

    const openModal = (modal) => {
        body.css('overflow-y', 'hidden');
        modal.addClass('show');
    };

    const closeModal = (modal) => {
        body.css('overflow-y', 'auto');
        modal.removeClass('show');
        modal.off();
    };

    $(document).on('click', '[data-toggle="modal"]', (e) => {
        e.preventDefault();

        const toggle = $(e.target);
        const modal = $(toggle.data('target'));
        openModal(modal);

        const modalContainer = modal.find('> .container');

        modal.on('click', (e) => {
            e.preventDefault();

            if (e.target == modal[0] || e.target == modalContainer[0]) {
                closeModal(modal);
            }
        });

        modal.on('click', '[data-dismiss="modal"]', (e) => {
            e.preventDefault();
            closeModal(modal);
        });
    });
});
